import { useQuery } from '@apollo/client';
import { Col, Row } from 'antd';
import React from 'react';

import { JobLocationSection } from '../newShipment/newShipmentElements';
import {
  fromServerDateOptional,
  toServerDateOptional,
} from '../../../common/utils/dateUtils';
import { FormItemDatePicker } from '../../../components/forms/dateElements';
import {
  AIRLINES_QUERY,
  AIRPORTS_QUERY,
} from '../../../app/graphql/jobQueries';
import AirlineAutoComplete from './components/AirlineAutoComplete';
import AirportAutoComplete from './components/AirportAutoComplete';
import SearchFlightFormItem from './components/SearchFlightsButton';

export default function AirRetrievalAirportOrRoute({ className }) {
  const { data, loading } = useQuery(AIRLINES_QUERY);
  const { data: airports, loading: isAirportsLoading } =
    useQuery(AIRPORTS_QUERY);

  return (
    <div className={className}>
      <Row justify="end">
        <SearchFlightFormItem disabled={isAirportsLoading || loading} />
      </Row>
      <Row gutter={20}>
        <Col span={12}>
          <JobLocationSection
            titleId="book.newAirRetrieval.departureAirport"
            requiredInTitle
          >
            <AirportAutoComplete
              name="routeDepartureAirport"
              airports={airports?.getAirports || []}
              rules={[{ required: true }]}
              isLoading={isAirportsLoading}
              isArrival={false}
            />
          </JobLocationSection>
        </Col>
        <Col span={12}>
          <JobLocationSection
            titleId="book.newAirRetrieval.arrivalAirport"
            requiredInTitle
          >
            <AirportAutoComplete
              name="routeArrivalAirport"
              airports={airports?.getAirports || []}
              rules={[{ required: true }]}
              isLoading={isAirportsLoading}
            />
          </JobLocationSection>
        </Col>
      </Row>
      <Row gutter={20}>
        <Col span={12}>
          <JobLocationSection titleId="book.newAirRetrieval.airline">
            <AirlineAutoComplete
              name="routeAirline"
              airlines={data?.getAirlines || []}
              isLoading={loading}
            />
          </JobLocationSection>
        </Col>
        <Col span={12}>
          <JobLocationSection
            titleId="book.newAirRetrieval.departure"
            requiredInTitle
          >
            <FormItemDatePicker
              name="routeDeparture"
              floatingLabel={false}
              rules={[{ required: true }]}
              formItemComponentProps={{
                formatValue: fromServerDateOptional,
                parseValue: toServerDateOptional,
              }}
            />
          </JobLocationSection>
        </Col>
      </Row>
    </div>
  );
}
